"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
define('templates',['handlebars'], function (Handlebars) {
  this["Handlebars"] = this["Handlebars"] || {};
  this["Handlebars"]["IRB"] = this["Handlebars"]["IRB"] || {};
  this["Handlebars"]["IRB"]["assign.overlay"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<div class=\"sixteen wide column\">\n  <ui type=\"form\" name=\"form\" />\n</div>";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["board.detail"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div style=\"line-height: 2.5em; margin-top: -1em;\">\n  <ui name=\"breadcrumb\" type=\"breadcrumb\" />\n</div>\n<h2 class=\"accessibility-text\">" + escapeExpression((helper = (helper = helpers.sectionTitle || (depth0 != null ? depth0.sectionTitle : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "sectionTitle",
        "hash": {},
        "data": data
      }) : helper)) + "</h2>\n<div id=\"boardDetails\" class=\"ui segment\">\n  <div class=\"ui fitted segment basic right aligned\">\n    <ui type=\"button\" name=\"saveButton\" text=\"Save\" color=\"primary\" icon=\"save\" />\n  </div>\n  <div class=\"ui hidden divider\" style=\"display: block !important\"></div>\n  <ui type=\"form\" name=\"form\" />\n\n  <div class=\"ui tertiary segment top attached\" style=\"padding: 0.5em; margin-top: 2em;\">\n    <ui type=\"button\" name=\"addMemberButton\" text=\"Add Member\" icon=\"plus\" floated=\"right\" size=\"small\" color=\"secondary\" />\n    <div style=\"line-height: 2.4em;\">\n      Review Board Roster as of:\n      <span style=\"margin-left: 0.5em;\">\n        <ui type=\"button\" color=\"white\" size=\"small\" compact=\"true\" icon=\"calendar\" name=\"dateButton\" />\n      </span>\n      <span style=\"margin-left: 1em;\">\n        <ui type=\"button\" inline=\"true\" name=\"todayButton\" text=\"Today\" color=\"blue\" size=\"large\" visible=\"false\" />\n      </span>\n    </div>\n  </div>\n  <div class=\"ui bottom attached segment fitted\">\n    <ui type=\"table\" name=\"table\" />\n    <ui type=\"dimmer\" name=\"dimmer\" inverted=\"true\" />\n  </div>\n</div>\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["board.member.detail"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["calendar"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "        <h2";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.hideCalendarHeaderFromScreens : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + ">" + escapeExpression((helper = (helper = helpers.calendarHeaderText || (depth0 != null ? depth0.calendarHeaderText : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "calendarHeaderText",
        "hash": {},
        "data": data
      }) : helper)) + "</h2>\n";
    },
    "2": function _(depth0, helpers, partials, data) {
      return " class=\"accessibility-text\"";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<div style=\"\">\n  <div class=\"ui grid unstackable\">\n    <div class=\"eight wide computer column\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.useCalendarHeader : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "    </div>\n    <div class=\"eight wide computer column right aligned\">\n      <ui type=\"dropdown\" name=\"boardDropdown\" />\n      <ui type=\"button\" name=\"addMeeting\" />\n    </div>\n  </div>\n</div>\n<div class=\"ui segment blue\" style=\"margin-top: 2em;\">\n  <div class=\"ui grid stackable\">\n    <nav class=\"eleven wide computer column\" aria-label=\"calendar date\">\n      <ui type=\"button\" name=\"todayButton\" />\n      <span style=\"display: inline-block; margin-left: 1em;\">\n        <ui type=\"button\" name=\"previousButton\" />\n        <ui type=\"button\" name=\"nextButton\" />\n      </span>\n      <span style=\"margin-left: 1em;\">\n        <ui type=\"header\" name=\"dateText\" tagName=\"span\" />\n      </span>\n    </nav>\n    <nav class=\"five wide computer column right aligned\" aria-label=\"calendar display\">\n      <ui type=\"menu\" name=\"calendarMenu\" />\n    </nav>\n  </div>\n</div>\n<div class=\"ui segment fitted basic bottom-container\">\n  <div class=\"ui segment fitted calendar-container\" style=\"height: 50em; position: relative;\">\n    <ui type=\"calendar\" name=\"calendar\" />\n  </div>\n  <div class=\"ui segment fitted calendar-week-container\" style=\"height: calc(100vh - 18.5em); position: relative; overflow: hidden;\">\n    <ui type=\"calendar-week\" name=\"calendarWeek\" />\n  </div>\n  <div class=\"calendar-list-container\">\n    <ui name=\"calendarList\" />\n  </div>\n</div>\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["dashboard.button"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "<div class=\"ui basic segment\">\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "min-height: " + escapeExpression((helper = (helper = helpers.minHeight || (depth0 != null ? depth0.minHeight : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "minHeight",
        "hash": {},
        "data": data
      }) : helper)) + "px;";
    },
    "5": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "      <i class=\"" + escapeExpression((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "icon",
          "hash": {},
          "data": data
        }) : helper)) + " icon\" style=\"";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.large : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(6, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\"></i>\n";
    },
    "6": function _(depth0, helpers, partials, data) {
      return "font-size: 2em;";
    },
    "8": function _(depth0, helpers, partials, data) {
      return "         <div class=\"external-icon\">\n           <svg width=\"50\" height=\"50\" viewBox=\"0 0 360 360\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n             <path d=\"M0.799988 336.8H124V359.198H0.799988V336.8Z\" fill=\"#1C4B77\"/>\n             <path d=\"M236 336.8H359.2V359.198H236V336.8Z\" fill=\"#1C4B77\"/>\n             <path d=\"M12 191.2H112.8V336.8H12V191.2Z\" fill=\"#1C4B77\"/>\n             <path d=\"M247.2 191.2H348V336.8H247.2V191.2Z\" fill=\"#1C4B77\"/>\n             <path d=\"M12 180H112.8C112.8 155.992 125.609 133.809 146.398 121.805C167.191 109.801 192.808 109.801 213.601 121.805C234.39 133.809 247.199 155.993 247.199 180H347.999V34.4001H11.999L12 180Z\" fill=\"#1C4B77\"/>\n             <path d=\"M12 0.800049H348C354.187 0.800049 359.199 6.98755 359.199 11.999C359.199 18.1865 354.183 23.198 348 23.198H12C5.81247 23.198 0.800964 17.0105 0.800964 11.999C0.800964 5.81155 5.81657 0.800049 12 0.800049Z\" fill=\"#1C4B77\"/>\n           </svg>\n         </div>\n";
    },
    "10": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "        <span class=\"text blue\">" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</span>\n";
    },
    "12": function _(depth0, helpers, partials, data) {
      return "        &nbsp;\n";
    },
    "14": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "         <div class=\"sub header\">" + escapeExpression((helper = (helper = helpers.subText || (depth0 != null ? depth0.subText : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "subText",
          "hash": {},
          "data": data
        }) : helper)) + "  <i class=\"" + escapeExpression((helper = (helper = helpers.arrowIcon || (depth0 != null ? depth0.arrowIcon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "arrowIcon",
          "hash": {},
          "data": data
        }) : helper)) + "\" style=\"";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.large : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(15, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\"></i></div>\n";
    },
    "15": function _(depth0, helpers, partials, data) {
      return "font-size: 1em;";
    },
    "17": function _(depth0, helpers, partials, data) {
      return "</div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.large : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "  <" + escapeExpression((helper = (helper = helpers.tagSize || (depth0 != null ? depth0.tagSize : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "tagSize",
        "hash": {},
        "data": data
      }) : helper)) + " class=\"ui header right aligned\" style=\"";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.minHeight : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " display: table;\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.icon : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.program(8, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "    <div class=\"content\" style=\"width: 100%;\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.text : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(10, data),
        "inverse": this.program(12, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "      <ui name=\"loader\"></ui>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.subText : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(14, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "    </div>\n  </" + escapeExpression((helper = (helper = helpers.tagSize || (depth0 != null ? depth0.tagSize : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "tagSize",
        "hash": {},
        "data": data
      }) : helper)) + ">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.large : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(17, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["dashboard.card"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div class=\"ui " + escapeExpression((helper = (helper = helpers.color || (depth0 != null ? depth0.color : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "color",
        "hash": {},
        "data": data
      }) : helper)) + " segment top attached\" style=\"padding: 0.78571em 1.5em 0.78571em;\">\n  <ui name=\"header\"></ui>\n</div>\n<div class=\"ui segment attached content body\" style=\"overflow-y: auto; overflow-x: hidden;\">\n  <ui name=\"loader\"></ui>\n  <div style=\"width: 100%; height: 100%;\">\n    <ui name=\"content\"></ui>\n  </div>\n</div>\n<ui name=\"button\"></ui>";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["dashboard"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<h2 class=\"accessibility-text\">Dashboard</h2>\n<div class=\"ui one column grid\">\n  <div class=\"column\"><ui type=\"container\" name=\"topContainer\" /></div>\n</div>\n<div class=\"ui grid one column\">\n  <div class=\"column\">\n    <section aria-label=\"Submission Filters\" class=\"dashboard-filters\">\n      <ui type=\"grid\" name=\"headerGrid\" stackable=\"true\" doubling=\"true\"></ui>\n    </section>\n    <section aria-label=\"Summaries\" class=\"dashboard-summaries\">\n      <ui type=\"grid\" name=\"contentGrid\" stackable=\"true\" doubling=\"true\" size=\"3\"></ui>\n    </section>\n  </div>\n</div>\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["decision.detail"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "<h4 class=\"ui header\">Recused</h4>\n<ui name=\"recused\" />\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<ui type=\"label\" name=\"decisionStatus\" ribbon=\"true\"></ui>\n<div class=\"ui hidden divider\" style=\"display: block !important\"></div>\n\n<ui type=\"form\" name=\"decisionForm\" />\n\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.recusedRequired : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\n<h4 class=\"ui dividing header categories-description\" tabindex=\"0\" style=\"display:none;\">Categories<div class=\"sub header\">Select the applicable categories for this decision.</div></h4>\n<ui type=\"form\" name=\"categoriesForm\" visible=\"false\" />\n\n<h4 class=\"ui header\">Findings<div class=\"sub header\">Information entered here can be used as part of the correspondence with the tag [FINDINGS].</div></h4>\n<ui name=\"findings\" />\n\n<h4 class=\"ui header\">Researcher Notes<div class=\"sub header\">Information entered here can be used as part of the correspondence with the tag [RESEARCH_NOTES]</div></h4>\n<ui name=\"researchersNotes\" />\n\n<h4 class=\"ui header\">Internal Notes</h4>\n<ui name=\"internalNotes\" />";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["decision.detail.summary"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "<h5 class=\"ui header\">Justification for Expiration</h5>\n<ui name=\"expirationJustification\" />\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "<h4 class=\"ui header\">Recused</h4>\n<ui name=\"recused\" />\n";
    },
    "5": function _(depth0, helpers, partials, data) {
      return "<h4 class=\"ui dividing header\">Categories</h4>\n<ui type=\"form\" name=\"categoriesForm\" />\n";
    },
    "7": function _(depth0, helpers, partials, data) {
      return "<h4 class=\"ui header\">Letters</h4>\n<ui type=\"table\" name=\"lettersTable\" />\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<ui type=\"label\" name=\"decisionStatus\" ribbon=\"true\"></ui>\n\n<h2 class=\"ui dividing header\">" + escapeExpression((helper = (helper = helpers.decisionTypeDescription || (depth0 != null ? depth0.decisionTypeDescription : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "decisionTypeDescription",
          "hash": {},
          "data": data
        }) : helper)) + "<div class=\"sub header\">" + escapeExpression((helper = (helper = helpers.decisionResultDate || (depth0 != null ? depth0.decisionResultDate : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "decisionResultDate",
          "hash": {},
          "data": data
        }) : helper)) + "</div></h2>\n<div class=\"ui hidden divider\" style=\"display: block !important\"></div>\n\n<ui type=\"form\" name=\"decisionForm\" />\n\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.useExpirationJustification : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.isRecusedAvailable : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n";
      stack1 = helpers['if'].call(depth0, (stack1 = (stack1 = depth0 != null ? depth0.model : depth0) != null ? stack1.categories : stack1) != null ? stack1.length : stack1, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n<h4 class=\"ui header\">Findings</h4>\n<ui name=\"findings\" />\n\n<h4 class=\"ui header\">Researchers Notes</h4>\n<ui name=\"researchersNotes\" />\n\n<h4 class=\"ui header\">Internal Notes</h4>\n<ui name=\"internalNotes\" />\n\n";
      stack1 = helpers['if'].call(depth0, (stack1 = depth0 != null ? depth0.letters : depth0) != null ? stack1.length : stack1, {
        "name": "if",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["document.letter.detail"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<div class=\"ui grid doubling two column\">\n  <div class=\"column\">\n    <ui name=\"breadcrumb\" type=\"breadcrumb\" />\n  </div>\n  <div class=\"column\">\n    <ui name=\"save\" type=\"button\" floated=\"right\" color=\"primary\" text=\"Save\" icon=\"save\" disabled=\"true\" />\n    <ui name=\"preview\" type=\"button\" floated=\"right\" basic=\"true\" color=\"teal\" text=\"Preview\" icon=\"file pdf outline\"></ui>\n    <ui name=\"delete\" type=\"button\" floated=\"right\" basic=\"true\" color=\"red\" text=\"Delete\" icon=\"remove\" />\n  </div>\n</div>\n<div id=\"submissionLetterDetails\" class=\"ui segment\">\n  <div style=\"position: absolute; top: 1em; right: 1em; z-index: 2;\">\n    <ui type=\"button\" size=\"mini\" text=\"CC\" name=\"cc\" compact=\"true\"></ui>\n    <ui type=\"button\" size=\"mini\" text=\"BCC\" name=\"bcc\" compact=\"true\"></ui>\n  </div>\n  <ui name=\"form\" type=\"form\" />\n</div>\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["dropdown.button"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "    <div class=\"dropdown-button-icon\">\n        <i class=\"" + escapeExpression((helper = (helper = helpers.buttonIcon || (depth0 != null ? depth0.buttonIcon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "buttonIcon",
          "hash": {},
          "data": data
        }) : helper)) + " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.favoriteRole : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.fluid : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(4, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + " icon\"></i>\n    </div>\n";
    },
    "2": function _(depth0, helpers, partials, data) {
      return "active";
    },
    "4": function _(depth0, helpers, partials, data) {
      return "right floated";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.buttonIcon : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "<div class=\"dropdown-text\">\n    " + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "\n</div>\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["email.message"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div>" + escapeExpression((helper = (helper = helpers.recipients || (depth0 != null ? depth0.recipients : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "recipients",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "<div>\n  <i>No Associated Email Addresses</i>\n</div>\n";
    },
    "5": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  <div><b>CC</b></div>\n  <div>" + escapeExpression((helper = (helper = helpers.cc || (depth0 != null ? depth0.cc : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "cc",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n  <div style=\"border-bottom: 1px solid #ccc; margin: 0.5em 0;\" />\n  <br><br>\n";
    },
    "7": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  <div><b>BCC</b></div>\n  <div>" + escapeExpression((helper = (helper = helpers.bcc || (depth0 != null ? depth0.bcc : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "bcc",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n  <div style=\"border-bottom: 1px solid #ccc; margin: 0.5em 0;\" />\n  <br><br>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<div><b>RECIPIENTS</b></div>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.recipients : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.program(3, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "<div style=\"border-bottom: 1px solid #ccc; margin: 0.5em 0;\" />\n<br><br>\n\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.cc : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.bcc : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n<div><b>SUBJECT</b></div>\n<div>" + escapeExpression((helper = (helper = helpers.subject || (depth0 != null ? depth0.subject : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "subject",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n<div style=\"border-bottom: 1px solid #ccc; margin: 0.5em 0;\" />\n<br><br>\n\n";
      stack1 = (helper = (helper = helpers.content || (depth0 != null ? depth0.content : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "content",
        "hash": {},
        "data": data
      }) : helper);
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["empty.table"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "        <div class=\"ui active inline " + escapeExpression((helper = (helper = helpers.loadingSize || (depth0 != null ? depth0.loadingSize : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "loadingSize",
          "hash": {},
          "data": data
        }) : helper)) + " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.text : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + " loader\">" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n";
    },
    "2": function _(depth0, helpers, partials, data) {
      return "text";
    },
    "4": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "        <" + escapeExpression((helper = (helper = helpers.headerTag || (depth0 != null ? depth0.headerTag : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "headerTag",
          "hash": {},
          "data": data
        }) : helper)) + " class=\"ui icon header\">\n          <i class=\"icon " + escapeExpression((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "icon",
          "hash": {},
          "data": data
        }) : helper)) + "\"";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.opacity : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "></i>\n          <div class=\"content\">\n            <div class=\"sub header\"";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.opacity : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += ">" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n          </div>\n        </" + escapeExpression((helper = (helper = helpers.headerTag || (depth0 != null ? depth0.headerTag : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "headerTag",
        "hash": {},
        "data": data
      }) : helper)) + ">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.button : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "5": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return " style=\"color: rgba(0, 0, 0, " + escapeExpression((helper = (helper = helpers.opacity || (depth0 != null ? depth0.opacity : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "opacity",
        "hash": {},
        "data": data
      }) : helper)) + ");\"";
    },
    "7": function _(depth0, helpers, partials, data) {
      return "        <div>\n          <ui name=\"button\"></ui>\n        </div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<td colspan=\"" + escapeExpression((helper = (helper = helpers.colspan || (depth0 != null ? depth0.colspan : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "colspan",
          "hash": {},
          "data": data
        }) : helper)) + "\" style=\"vertical-align: middle; overflow: hidden;\">\n  <div class=\"ui one column grid table-empty-content\">\n    <div class=\"column center aligned\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.loading : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.program(4, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "    </div>\n  </div>\n</td>\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["finder.item"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div class=\"content\">\n  <i class=\"right floated icon remove\"></i>\n  <div class=\"description\">" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n</div>";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["finder.overlay"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div class=\"twelve wide computer column sixteen wide tablet column\">\n  <ui name=\"searchList\" />\n</div>\n<div class=\"four wide computer column sixteen wide tablet column\">\n  <div class=\"ui small header\">" + escapeExpression((helper = (helper = helpers.headerText || (depth0 != null ? depth0.headerText : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "headerText",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n  <div class=\"ui fitted segment\" style=\"min-height: 44px\"><ui name=\"addedList\" /></div>\n</div>\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["flag.selection.container"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<h3 id=\"flagsTitle\" class=\"accessibility-text\">Flags</h3>\n<div id=\"flagsDescription\" class=\"accessibility-text\">\n  The following are lists of flags that can or have be assigned to the study. Use the tab key and shift+tab to\n  navigate the flags lists. Use the enter key to assign or unassign a flag to the current study. Items will be read aloud\n  as follows: flag category followed by flag name, and finally the current state, if any, for that item. If a flag has been\n  assigned and the assignment saved, the current state is read as \"selected\". If a flag has been assigned and is\n  pending being saved, the current state is read as \"selected, unsaved\". If a flag has been unassigned and is pending\n  being saved, the current state is read as \"removing, unsaved\". If a flag is unselected, no state is read aloud. If you\n  assign or unassign a flag, the current state of the flag will be read aloud as confirmation of your action.\n</div>\n<div id=\"flagsAnnouncer\" role=\"alert\" aria-live=\"assertive\" class=\"accessibility-text\"></div>\n<div class=\"ui fitted segment flag-selection-container\">\n  <ui\n    type=\"button\"\n    name=\"saveButton\"\n    classname=\"ui button save-button\"\n    text=\"Save\"\n    color=\"primary\"\n    disabled=\"true\"\n    floated=\"right\"\n  />\n  <ui type=\"container\" name=\"tablesContainer\" classname=\"clear container tables-container\" />\n</div>\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["flags.table.header"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression;
      return "  <span class=\"accessibility-text\">" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.model : depth0) != null ? stack1.text : stack1, depth0)) + "</span>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression;
      return "  <span role=\"heading\" aria-level=\"3\">" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.model : depth0) != null ? stack1.text : stack1, depth0)) + "</span>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.useAccessibilityText : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.program(3, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["html.viewer.checkbox"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "radio";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "checkbox";
    },
    "5": function _(depth0, helpers, partials, data) {
      return "checked=\"checked\"";
    },
    "7": function _(depth0, helpers, partials, data) {
      return "disabled=\"disabled\"";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<input type=\"";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.radio : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.program(3, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\" name=\"" + escapeExpression((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "name",
        "hash": {},
        "data": data
      }) : helper)) + "\" ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.value : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.disabled : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += ">\n<label>";
      stack1 = (helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper);
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</label>";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["html.viewer"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        buffer = "  ";
      stack1 = (helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper);
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\n  <div style=\"clear: both;\"></div>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  <span style=\"color: rgba(0, 0, 0, 0.5); \">" + escapeExpression((helper = (helper = helpers.placeholder || (depth0 != null ? depth0.placeholder : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "placeholder",
        "hash": {},
        "data": data
      }) : helper)) + "</span>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1;
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.text : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.program(3, data),
        "data": data
      });
      if (stack1 != null) {
        return stack1;
      } else {
        return '';
      }
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["html.viewer.list.item"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        buffer = "<div class=\"content\">\n  <div class=\"description\">";
      stack1 = (helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper);
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>\n</div>";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["iframe"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "    <iframe id=\"reportingFrame\" src=\"" + escapeExpression((helper = (helper = helpers.iframeSrc || (depth0 != null ? depth0.iframeSrc : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "iframeSrc",
        "hash": {},
        "data": data
      }) : helper)) + "\" />\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "    <H3>Beta Reporting will become available once your institution upgrades to the New Cayuse Platform.</H3>\n    <iframe id=\"reportingFrame\" src=\"" + escapeExpression((helper = (helper = helpers.iframeSrc || (depth0 != null ? depth0.iframeSrc : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "iframeSrc",
        "hash": {},
        "data": data
      }) : helper)) + "\" style=\"height:0; width:0;\" />\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<div>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.showIframe : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.program(3, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["image.chooser"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<div class=\"ui segment basic very padded\">\n  <h5 class=\"ui header\">\n    Choose source:\n  </h5>\n  <table role=\"presentation\" style=\"width: 100%;\">\n    <tr>\n      <td style=\"width: 150px; vertical-align: top;\">\n        <ui name=\"uploadTypeForm\" />\n      </td>\n      <td style=\"vertical-align: top;\">\n        <div data-index=\"0\" style=\"display: none;\">\n          <ui name=\"uploadInput\" />\n        </div>\n        <div data-index=\"1\" style=\"display: none;\">\n          <div class=\"ui form\">\n            <div class=\"field\">\n              <label>Paste the URL for your image.</label>\n              <ui name=\"webLinkInput\" />\n            </div>\n          </div>\n        </div>\n        <div data-index=\"2\" style=\"display: none;\">\n          <div class=\"ui form\">\n            <div class=\"field\">\n              <label>Paste the image from your clipboard.</label>\n              <ui name=\"pasteInput\" />\n            </div>\n          </div>\n        </div>\n      </td>\n    </tr>\n  </table>\n</div>\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["input.date"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<div class=\"calendar-field-wrapper\">\n    <ui type=\"input\" name=\"input\"></ui>\n    <button class=\"calendar-icon\" aria-label=\"Choose Date\">\n        <i class=\"calendar icon\"></i>\n    </button>\n</div>";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["instant.notification"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "    <td class=\"icon-column\">\n      <i class=\"icon " + escapeExpression((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "icon",
        "hash": {},
        "data": data
      }) : helper)) + " " + escapeExpression((helper = (helper = helpers.iconColor || (depth0 != null ? depth0.iconColor : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "iconColor",
        "hash": {},
        "data": data
      }) : helper)) + "\"></i>\n    </td>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        buffer = "<div class=\"sub header\">";
      stack1 = (helper = (helper = helpers.details || (depth0 != null ? depth0.details : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "details",
        "hash": {},
        "data": data
      }) : helper);
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        buffer = "<table role=\"presentation\" style=\"width: 100%\">\n  <tr>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.icon : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "    <td class=\"content-column\">\n      <div class=\"ui tiny inverted header\">\n        ";
      stack1 = (helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "title",
        "hash": {},
        "data": data
      }) : helper);
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n        ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.details : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\n      </div>\n    </td>\n    <td class=\"actions-column\"></td>\n  </tr>\n</table>\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["legacy.layout"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<div class=\"sidebar\"></div>\n<div class=\"pusher\">\n  <div id=\"notifications\"></div>\n  <div class=\"legacy\"></div>\n  <div class=\"main\" style=\"display:none;\"></div>\n  <div class=\"legacyDimmer\"></div>\n</div>\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["legacy.upload"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div class=\"ui basic segment fitted\">\n  <div class=\"ui left floated buttons\">\n    <ui type=\"container\" name=\"leftActions\" />\n  </div>\n  <div class=\"ui right floated buttons\">\n    <ui type=\"container\" name=\"actions\" />\n  </div>\n</div>\n<h1 class=\"accessibility-text\">" + escapeExpression((helper = (helper = helpers.pageTitle || (depth0 != null ? depth0.pageTitle : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "pageTitle",
        "hash": {},
        "data": data
      }) : helper)) + "</h1>\n<ui type=\"steps\" name=\"steps\"/>\n<div class=\"ui basic fitted segment\">\n  <div class=\"ui segment\" data-step=\"0\">\n    <div role=\"heading\" aria-level=\"2\" class=\"ui small header\">\n      Upload:\n      <div class=\"sub header\">Choose the CSV file that you wish to import.</div>\n    </div>\n    <ui type=\"input\" name=\"fileInput\" buttonRight=\"false\" />\n  </div>\n\n  <div class=\"ui basic fitted segment\" data-step=\"1\">\n    <h2 class=\"accessibility-text\">" + escapeExpression((helper = (helper = helpers.resultsTitle || (depth0 != null ? depth0.resultsTitle : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "resultsTitle",
        "hash": {},
        "data": data
      }) : helper)) + "</h2>\n    <ui type=\"container\" name=\"results\" />\n    <div class=\"ui basic fitted right aligned segment\">\n      <ui type=\"text\" name=\"numOfResults\" />\n    </div>\n  </div>\n\n  <div class=\"ui center aligned segment\" data-step=\"2\">\n    <div role=\"heading\" aria-level=\"2\" class=\"ui medium header\">Successfully imported legacy study data.</div>\n    <ui type=\"button\" name=\"redoBtn\" />\n  </div>\n</div>\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["letter.template.detail"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<table role=\"presentation\" style=\"width: 100%;\">\n  <tbody>\n    <tr>\n      <td>\n        <div style=\"line-height: 2.5em; margin-top: -1em;\">\n          <ui name=\"breadcrumb\" type=\"breadcrumb\" />\n        </div>\n      </td>\n      <td>\n        <ui name=\"save\" type=\"button\" floated=\"right\" color=\"primary\" text=\"Save\" icon=\"save\" />\n        <ui name=\"delete\" type=\"button\" floated=\"right\" basic=\"true\" color=\"red\" text=\"Delete\" icon=\"remove\" />\n      </td>\n    </tr>\n  </tbody>\n</table>\n<h2 class=\"accessibility-text\">" + escapeExpression((helper = (helper = helpers.pageTitle || (depth0 != null ? depth0.pageTitle : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "pageTitle",
        "hash": {},
        "data": data
      }) : helper)) + "</h2>\n<div id=\"letterDetails\" class=\"ui segment\" style=\"min-height: 100%;\">\n  <ui name=\"form\" type=\"form\" />\n</div>\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["list.pagination"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "  <div class=\"ui center aligned grid\">\n    <div class=\"sixteen wide column\">\n      <ui name=\"title\" />\n    </div>\n    <div class=\"sixteen wide column\">\n      <ui name=\"pageNumbers\" /> \n    </div>\n    <div class=\"sixteen wide column\">\n      <ui name=\"pageSizeDropdown\" />\n    </div>\n  </div>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "  <div class=\"ui middle aligned grid\">\n    <div class=\"seven wide column\">\n      <ui name=\"pageSizeDropdown\" />\n    </div>\n    <div class=\"center aligned two wide column\">\n      <ui name=\"title\" />\n    </div>\n    <div class=\"right aligned seven wide column\">\n      <ui name=\"pageNumbers\" /> \n    </div>\n  </div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<div style=\"position: relative;\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.responsive : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.program(3, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["main.layout"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<div style=\"height: 0; width: 0; color: transparent\">---</div>\n<div style=\"height: 0; width: 0; color: transparent\">---</div>\n<a id=\"skipLink\" href=\"#irb-content\" class=\"skip-link\">Skip to Main Content</a>\n<header class=\"header\" role=\"banner\" aria-label=\"Site Header\"></header>\n<div style=\"height: inherit; position: relative;\">\n  <div id=\"live-text\" aria-live=\"assertive\" role=\"region\" class=\"accessibility-text\">\n  </div>\n  <main role=\"main\" aria-label=\"content\" name=\"irb-content\" id=\"irb-content\" tabindex=\"-1\" class=\"content\" style=\"height: inherit;\"></main>\n  <div class=\"overlay\"></div>\n  <div class=\"dimmerContainer\"></div>\n</div>\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["meeting.agenda.content"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<b>Board Name:</b> [MEETING_BOARD] \n<br/>\n<b>Meeting Date:</b> [MEETING_TIME]\n<br/>\n<b>Meeting Location:</b> [MEETING_LOCATION]\n <br/>\n <br/>\n<p>An upcoming meeting has been scheduled for [MEETING_BOARD] on [MEETING_TIME].  Please see the attached agenda for a list of submissions that will be reviewed during the meeting.</p>\n<p>To view the meeting details and agenda in Cayuse IRB please click <a href=\"[MEETING_URL]\">here</a>.</p>\n\nThank you.\n ";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["meeting.agenda.letter"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<div class=\"ui segment\">\n  <div style=\"position: absolute; top: 1em; right: 1em; z-index: 2;\">\n    <ui type=\"button\" size=\"mini\" text=\"CC\" name=\"ccBtn\" compact=\"true\"></ui>\n    <ui type=\"button\" size=\"mini\" text=\"BCC\" name=\"bccBtn\" compact=\"true\"></ui>\n  </div>\n  <ui name=\"letterForm\" type=\"form\" />\n</div>";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["meeting.detail"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "  <h2";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.hideHeaderFromScreens : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + ">" + escapeExpression((helper = (helper = helpers.headerText || (depth0 != null ? depth0.headerText : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "headerText",
        "hash": {},
        "data": data
      }) : helper)) + "</h2>\n";
    },
    "2": function _(depth0, helpers, partials, data) {
      return " class=\"accessibility-text\"";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<div class=\"ui basic fitted segment\">\n  <ui type=\"breadcrumb\" name=\"breadcrumb\" />\n  <div class=\"ui buttons right floated\">\n    <ui name=\"sendAgenda\" icon=\"send outline\" type=\"button\" color=\"white\" text=\"Send Agenda\" />\n    <ui name=\"viewAgenda\" icon=\"file pdf outline\" type=\"button\" color=\"white\" text=\"Agenda\" />\n    <ui name=\"viewMinutes\" icon=\"file pdf outline\" type=\"button\" color=\"white\" text=\"Minutes\" />\n    <ui name=\"finalizeMeeting\" type=\"button\" color=\"primary\" visible=\"false\" text=\"Approve Minutes\"/>\n    <ui name=\"endMeeting\" type=\"button\" color=\"primary\" visible=\"false\" text=\"End Meeting\" />\n    <ui name=\"startMeeting\" type=\"button\" color=\"primary\" visible=\"false\" text=\"Start Meeting\" />\n  </div>\n</div>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.useHeader : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "<nav class=\"ui segment board-navigation-buttons\" aria-label=\"meetings by board\">\n  <ui type=\"button\" name=\"previousMeetingButton\" />\n  <ui type=\"button\" name=\"nextMeetingButton\" />\n</nav>\n<ui type=\"message\" name=\"errorMessages\" format=\"error\" header=\"Something Went Wrong\" visible=\"false\" dismissable=\"true\"/>\n<div id=\"meetingDetails\" class=\"ui segment meeting-details\">\n  <ui type=\"container\" name=\"status\" />\n  <ui type=\"container\" name=\"actions\" />\n  <div class=\"ui header\" style=\"margin-top: 0;\">\n    <ui type=\"text\" name=\"boardName\"/>\n    <div class=\"sub header\">\n      <ui type=\"text\" name=\"boardDate\" />\n    </div>\n    <div class=\"sub header\">\n      <ui type=\"text\" name=\"boardTime\"/>\n    </div>\n    <div class=\"sub header\">\n      <ui type=\"text\" name=\"boardLocation\"/>\n    </div>\n  </div>\n\n  <ui type=\"container\" name=\"toolbar\" />\n\n  <ui type=\"form\" name=\"meetingEditForm\" />\n\n  <h3 class=\"ui dividing header\">Agenda</h3>\n  <ui id=\"agendaForm\" type=\"form\" name=\"agendaForm\" />\n\n  <h3 class=\"ui dividing header\">Notes</h3>\n  <ui type=\"form\" name=\"notesForm\" />\n</div>\n<div class=\"ui segment meeting-tab-segment\">\n  <ui type=\"tabs\" name=\"tabs\" />\n</div>\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["meeting.detail.tabs.dimmer.container"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<h2 class=\"accessibility-text\">" + escapeExpression((helper = (helper = helpers.tableHeaderText || (depth0 != null ? depth0.tableHeaderText : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "tableHeaderText",
        "hash": {},
        "data": data
      }) : helper)) + "</h2>\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["meeting.summary"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  <div class=\"sub header\" style=\"line-height: 1.4em;\">" + escapeExpression((helper = (helper = helpers.location || (depth0 != null ? depth0.location : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "location",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        buffer = "<h4 class=\"ui header\">\n  " + escapeExpression(lambda((stack1 = depth0 != null ? depth0.group : depth0) != null ? stack1.name : stack1, depth0)) + "\n  <div class=\"sub header\" style=\"line-height: 1.4em;\">" + escapeExpression((helper = (helper = helpers.startTime || (depth0 != null ? depth0.startTime : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "startTime",
          "hash": {},
          "data": data
        }) : helper)) + " - " + escapeExpression((helper = (helper = helpers.endTime || (depth0 != null ? depth0.endTime : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "endTime",
          "hash": {},
          "data": data
        }) : helper)) + "</div>\n  <div class=\"sub header\" style=\"line-height: 1.4em;\">" + escapeExpression((helper = (helper = helpers.duration || (depth0 != null ? depth0.duration : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "duration",
          "hash": {},
          "data": data
        }) : helper)) + "</div>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.location : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</h4>\n<div>\n  <div style=\"padding-bottom: 8px;\">\n    <ui name=\"more\" />\n  </div>\n  <div>\n    <ui name=\"agenda\" />\n  </div>\n</div>\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["menu.app.header"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<a href=\"" + escapeExpression((helper = (helper = helpers.logoHref || (depth0 != null ? depth0.logoHref : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "logoHref",
        "hash": {},
        "data": data
      }) : helper)) + "\" class=\"product-logo\">" + escapeExpression((helper = (helper = helpers.logoLinkText || (depth0 != null ? depth0.logoLinkText : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "logoLinkText",
        "hash": {},
        "data": data
      }) : helper)) + "</a>\n<ui name=\"title\" />\n<div role=\"menubar\" aria-label=\"User preferences and notifications\" class=\"right menu\"></div>\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["message.template.detail"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div class=\"ui grid doubling two column\">\n  <div class=\"column\">\n    <ui name=\"breadcrumb\" />\n  </div>\n  <div class=\"column\">\n    <ui name=\"save\" floated=\"right\" color=\"primary\" text=\"Save\" icon=\"save\" />\n    <ui name=\"preview\" floated=\"right\" basic=\"false\" color=\"white\" text=\"Preview\" icon=\"file pdf outline\"></ui>\n    <ui name=\"revert\" floated=\"right\" basic=\"false\" color=\"white\" text=\"Revert\" icon=\"undo\" />\n  </div>\n</div>\n<h1 class=\"accessibility-text\">" + escapeExpression((helper = (helper = helpers.sectionTitle || (depth0 != null ? depth0.sectionTitle : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "sectionTitle",
        "hash": {},
        "data": data
      }) : helper)) + "</h1>\n<div id=\"messageTemplateControl\" class=\"ui segment\" >\n  <ui name=\"header\" tagName=\"h4\"/>\n  <ui name=\"messageTemplateEditor\" />\n</div>\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["message.template.editor"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div class=\"form-container\" style=\"" + escapeExpression((helper = (helper = helpers.containerStyle || (depth0 != null ? depth0.containerStyle : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "containerStyle",
        "hash": {},
        "data": data
      }) : helper)) + "\">\n  <div style=\"" + escapeExpression((helper = (helper = helpers.toolbarStyle || (depth0 != null ? depth0.toolbarStyle : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "toolbarStyle",
        "hash": {},
        "data": data
      }) : helper)) + "\">\n    <ui type=\"button\" size=\"mini\" text=\"CC\" name=\"ccButton\" compact=\"true\"></ui>\n    <ui type=\"button\" size=\"mini\" text=\"BCC\" name=\"bccButton\" compact=\"true\"></ui>\n  </div>\n  <ui name=\"form\" type=\"form\" />\n</div>\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["message.template.status"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "<div class=\"ui label circular empty yellow\"></div>&nbsp; Custom\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      return " <div class=\"ui label circular empty green\"></div>&nbsp; Default\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.override : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.program(3, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["notification.item"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "  <div class=\"sub header\">" + escapeExpression((helper = (helper = helpers.studyLabel || (depth0 != null ? depth0.studyLabel : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "studyLabel",
          "hash": {},
          "data": data
        }) : helper)) + " &nbsp; ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.principalInvestigator : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>\n";
    },
    "2": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "| &nbsp; PI: " + escapeExpression((helper = (helper = helpers.principalInvestigator || (depth0 != null ? depth0.principalInvestigator : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "principalInvestigator",
        "hash": {},
        "data": data
      }) : helper));
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<h5 class=\"ui header\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.studyLabel : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "  " + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "\n  <div class=\"sub header\">\n    <small>" + escapeExpression((helper = (helper = helpers.time || (depth0 != null ? depth0.time : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "time",
        "hash": {},
        "data": data
      }) : helper)) + "</small>\n  </div>\n</h5>";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["notifications"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div class=\"ui segment top attached\" style=\"padding: 0.5em;\">\n  <h5 tabindex=\"0\" id=\"notificationsHeader\" class=\"ui header\">\n    <ui type=\"text\" name=\"headerText\" text=\"Notifications\"></ui>\n    <span style=\"float: right;\">\n      <ui type=\"dropdown\" id=\"notifications-menu\" name=\"actions\" mode=\"button\" inline=\"true\" icon=\"ellipsis horizontal\" pointing=\"right\" circular=\"true\"></ui>\n    </span>\n  </h5>\n</div>\n<div class=\"ui segment bottom attached scroll-container\" style=\"overflow-y: auto; overflow-x: hidden; max-height: " + escapeExpression((helper = (helper = helpers.maxTableHeight || (depth0 != null ? depth0.maxTableHeight : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "maxTableHeight",
        "hash": {},
        "data": data
      }) : helper)) + "px; padding: 0;\">\n  <ui type=\"table\" name=\"table\" headless=\"true\" basic=\"true\" borderless=\"true\"></ui>\n  <div>\n    <ui type=\"header\" name=\"loadingText\" visible=\"false\" subText=\"Loading More Notifications\" aligned=\"center\" tagName=\"h5\">\n  </div>\n</div>\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["organization.list"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<h2 class=\"accessibility-text\">" + escapeExpression((helper = (helper = helpers.pageTitle || (depth0 != null ? depth0.pageTitle : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "pageTitle",
        "hash": {},
        "data": data
      }) : helper)) + "</h2>\n<div class=\"ui grid\">\n  <div class=\"five wide column computer only\">\n    <div id=\"org-tree-container\">\n      <div class=\"ui segment top attached\" style=\"padding-top: 0.6em; padding-bottom: 0.6em;\">\n        <ui type=\"input\" name=\"orgSearch\" fluid=\"true\" transparent=\"true\" icon=\"search\" placeholder=\"Search\" />\n      </div>\n      <div class=\"ui segment secondary attached\" style=\"padding-top: 0.6em; padding-bottom: 0.6em;\">\n          <ui type=\"breadcrumb\" name=\"breadcrumb\" />\n      </div>\n      <ui name=\"orgHeader\"></ui>\n      <div class=\"ui segment bottom attached fitted\">\n        <ui type=\"table-navigation\" name=\"orgTree\" />\n        <ui type=\"table\" name=\"orgTable\" headless=\"true\" basic=\"true\" borderless=\"true\" sortable=\"false\" visible=\"false\" />\n      </div>\n    </div>\n  </div>\n  <div class=\"eleven wide computer sixteen wide column\">\n    <div class=\"ui grid one column\" id=\"emptyDisplay\">\n      <div class=\"column center aligned\">\n        <div class=\"ui icon header\" style=\"margin-top: 30vh;\">\n          <i class=\"icon university\" style=\"color: rgba(0, 0, 0, 0.5);\"></i>\n          <div class=\"content\">\n            <div class=\"sub header\" style=\"color: rgba(0, 0, 0, 0.5);\">Choose an organzation.</div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div id=\"org-approver-container\" class=\"ui sticky\" style=\"display: none;\">\n      <div class=\"ui blue segment\">\n\n        <ui type=\"button\" name=\"addApproverButton\" disabled=\"true\" text=\"Add Approver\" icon=\"plus\" color=\"primary\" floated=\"right\"  />\n        <ui type=\"button\" name=\"undoButton\" disabled=\"true\" text=\"Undo\" icon=\"undo\" floated=\"right\"  />\n        <div>\n          <h3 id=\"orgApproversHeader\" class=\"ui header org-approver-details\" style=\"line-height: 2em;\">\n            <ui type=\"text\" name=\"approversTitle\" />\n          </h3>\n        </div>\n      </div>\n      <div class=\"ui fitted segment\" style=\"\">\n        <ui type=\"table\" name=\"approverTable\" basic=\"true\" borderless=\"true\" sortable=\"false\" />\n      </div>\n    </div>\n  </div>\n</div>\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["overlay.layout"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div class=\"dimmer\" style=\"position: absolute; z-index: 1; top: 0px; left: 0px; right: 0px; bottom: 0px; background: " + escapeExpression((helper = (helper = helpers.dimmerBackground || (depth0 != null ? depth0.dimmerBackground : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "dimmerBackground",
        "hash": {},
        "data": data
      }) : helper)) + ";\"></div>\n<div id=\"overlayContainer\" class=\"offset\" style=\"position: absolute; top: 0px; right: 0px; bottom: 0px; background: " + escapeExpression((helper = (helper = helpers.background || (depth0 != null ? depth0.background : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "background",
        "hash": {},
        "data": data
      }) : helper)) + "; box-shadow: " + escapeExpression((helper = (helper = helpers.boxShadow || (depth0 != null ? depth0.boxShadow : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "boxShadow",
        "hash": {},
        "data": data
      }) : helper)) + "; z-index: 2; overflow: auto; padding: " + escapeExpression((helper = (helper = helpers.padding || (depth0 != null ? depth0.padding : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "padding",
        "hash": {},
        "data": data
      }) : helper)) + ";\">\n  <section class=\"ui basic fitted segment\" style=\"z-index: 3;\">\n    <div class=\"ui grid\">\n      <div class=\"column\">\n        <ui name=\"button\" />\n        <ui name=\"buttonContainer\" />\n        <ui name=\"cancelButton\" />\n        <div class=\"ui header\" style=\"margin-top: 0em;\">\n          <ui name=\"header\"></ui>\n          <div class=\"sub header\"><ui name=\"subHeader\"></ui></div>\n        </div>\n      </div>\n    </div>\n  </section>\n  <div class=\"content\"></div>\n</div>\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["page.list"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<div class=\"ui grid\" style=\"font-size: 1em;\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.usePageHeader : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "  <div class=\"eight wide column right aligned right floated\">\n    <ui type=\"container\" name=\"headerRightContainer\"></ui>\n  </div>\n  <div class=\"eight wide column left floated\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.breadcrumbs : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "    <ui type=\"container\" name=\"headerLeftContainer\"></ui>\n  </div>\n  <div style=\"clear: both;\"></div>\n</div>\n";
    },
    "2": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "  <h2";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.hideSectionTitleFromScreens : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + ">" + escapeExpression((helper = (helper = helpers.sectionTitle || (depth0 != null ? depth0.sectionTitle : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "sectionTitle",
        "hash": {},
        "data": data
      }) : helper)) + "</h2>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      return " class=\"accessibility-text\"";
    },
    "5": function _(depth0, helpers, partials, data) {
      return "      <ui type=\"breadcrumb\" name=\"breadcrumb\" />\n";
    },
    "7": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "  <h" + escapeExpression((helper = (helper = helpers.tableHeaderLevel || (depth0 != null ? depth0.tableHeaderLevel : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "tableHeaderLevel",
          "hash": {},
          "data": data
        }) : helper));
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.hideTableHeaderFromScreens : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + " id=\"" + escapeExpression((helper = (helper = helpers.tableHeaderId || (depth0 != null ? depth0.tableHeaderId : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "tableHeaderId",
        "hash": {},
        "data": data
      }) : helper)) + "\">" + escapeExpression((helper = (helper = helpers.tableHeaderText || (depth0 != null ? depth0.tableHeaderText : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "tableHeaderText",
        "hash": {},
        "data": data
      }) : helper)) + "</h" + escapeExpression((helper = (helper = helpers.tableHeaderLevel || (depth0 != null ? depth0.tableHeaderLevel : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "tableHeaderLevel",
        "hash": {},
        "data": data
      }) : helper)) + ">\n";
    },
    "9": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.visualsearch : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(10, data),
        "inverse": this.program(12, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\n";
    },
    "10": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  <div role=\"search\" aria-label=\"Filter this list\" class=\"ui segment " + escapeExpression((helper = (helper = helpers.searchSegmentColor || (depth0 != null ? depth0.searchSegmentColor : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "searchSegmentColor",
        "hash": {},
        "data": data
      }) : helper)) + " " + escapeExpression((helper = (helper = helpers.searchSegmentAttached || (depth0 != null ? depth0.searchSegmentAttached : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "searchSegmentAttached",
        "hash": {},
        "data": data
      }) : helper)) + " attached vs container\">\n    <ui type=\"visualsearch\" name=\"visualsearchView\" />\n  </div>\n  <div class=\"ui segment bottom attached fitted\">\n";
    },
    "12": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  <div role=\"search\" aria-label=\"Search this list\" class=\"ui segment " + escapeExpression((helper = (helper = helpers.searchSegmentColor || (depth0 != null ? depth0.searchSegmentColor : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "searchSegmentColor",
        "hash": {},
        "data": data
      }) : helper)) + " " + escapeExpression((helper = (helper = helpers.searchSegmentAttached || (depth0 != null ? depth0.searchSegmentAttached : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "searchSegmentAttached",
        "hash": {},
        "data": data
      }) : helper)) + " attached\">\n    <ui type=\"input\" name=\"searchView\" icon=\"search\" fluid=\"true\" />\n  </div>\n  <div class=\"ui segment bottom attached fitted\">\n";
    },
    "14": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.toolbar : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(15, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "<div class=\"ui segment fitted bottom-segment " + escapeExpression((helper = (helper = helpers.scrollbar || (depth0 != null ? depth0.scrollbar : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "scrollbar",
        "hash": {},
        "data": data
      }) : helper)) + "\">\n";
    },
    "15": function _(depth0, helpers, partials, data) {
      return "<div class=\"ui segment top attached\">\n  <div class=\"ui two column grid\">\n    <div class=\"column\">\n      <ui type=\"container\" name=\"toolbarLeftContainer\"></ui>\n    </div>\n    <div class=\"column right aligned\">\n      <ui type=\"container\" name=\"toolbarRightContainer\"></ui>\n    </div>\n  </div>\n</div>\n<div class=\"ui segment bottom attached fitted\">\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.headerOrBreadcrumbs : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.useTableHeader : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.search : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(9, data),
        "inverse": this.program(14, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "  <div>\n    <ui type=\"table\" name=\"table\" basic=\"true\" borderless=\"true\" compact=\"true\" striped=\"false\" fixedHeader=\"true\" fixedHeaderTopOffset=\"41\" fixedHeaderTopPosition=\"40.5\" fixedHeaderBackground=\"#fcfcfc\" />\n  </div>\n  <ui type=\"dimmer\" name=\"dimmer\" inverted=\"true\" centered=\"true\" />\n</div>\n<ui name=\"pagination\" />\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["page.tabs"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return " class=\"accessibility-text\"";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<div class=\"ui basic segment fitted\">\n  <ui type=\"breadcrumb\" name=\"breadcrumb\"></ui>\n  <h2";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.hideSectionTitleFromScreens : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + ">" + escapeExpression((helper = (helper = helpers.sectionTitle || (depth0 != null ? depth0.sectionTitle : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "sectionTitle",
        "hash": {},
        "data": data
      }) : helper)) + "</h2>\n  <ui type=\"button\" name=\"createBtn\" visible=\"false\"></ui>\n  <ui type=\"dropdown\" name=\"createDropdown\" mode=\"button\"></ui>\n</div>\n<div class=\"ui basic segment fitted\">\n  <ui type=\"tabs\" name=\"tabs\" />\n</div>\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["paging.view"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["product.menu.tree.item"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "    <a tabindex=\"-1\" class=\"text\" ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.href : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.target : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(4, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + ">" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</a>\n";
    },
    "2": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "href=\"" + escapeExpression((helper = (helper = helpers.href || (depth0 != null ? depth0.href : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "href",
        "hash": {},
        "data": data
      }) : helper)) + "\"";
    },
    "4": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "target=\"" + escapeExpression((helper = (helper = helpers.target || (depth0 != null ? depth0.target : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "target",
        "hash": {},
        "data": data
      }) : helper)) + "\"";
    },
    "6": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "    <span class=\"text\">" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</span>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<div class=\"title\" tabindex=\"-1\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.link : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.program(6, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>\n<div class=\"content\"></div>\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["report.accordion"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        buffer = "  <div class=\"title\" role=\"heading\" aria-level=\"1\" data-index=\"" + escapeExpression(lambda(data && data.index, depth0)) + "\">\n    <i class=\"";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.icon : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.program(4, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + " icon\"></i>\n    <div class=\"ui empty circular " + escapeExpression((helper = (helper = helpers.color || (depth0 != null ? depth0.color : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "color",
        "hash": {},
        "data": data
      }) : helper)) + " label\" style=\"margin: 0em 0.5em\"></div>\n    " + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "\n  </div>\n  <div class=\"content\"></div>\n";
    },
    "2": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return escapeExpression((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "icon",
        "hash": {},
        "data": data
      }) : helper));
    },
    "4": function _(depth0, helpers, partials, data) {
      return "dropdown";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1;
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.items : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        return stack1;
      } else {
        return '';
      }
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["report.column"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div style=\"float: right;\">\n  <ui type=\"label\" name=\"columnType\" />\n  <ui type=\"dropdown\" name=\"columnOptions\" />\n</div>\n<div style=\"position: absolute; top: 50%; transform: translateY(-50%);\">" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</div>";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["report.detail"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div class=\"ui basic fitted segment\">\n  <ui type=\"breadcrumb\" name=\"breadcrumb\" />\n  <nav aria-label=\"report controls\"class=\"ui buttons right floated report-detail-nav\">\n    <ui name=\"deleteBtn\" type=\"button\" />\n    <ui name=\"exportBtn\" type=\"button\" />\n    <ui name=\"previewBtn\" type=\"button\" />\n    <ui name=\"saveBtn\" type=\"button\" />\n  </nav>\n</div>\n<h2 class=\"accessibility-text\">" + escapeExpression((helper = (helper = helpers.reportDetailsTitle || (depth0 != null ? depth0.reportDetailsTitle : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "reportDetailsTitle",
        "hash": {},
        "data": data
      }) : helper)) + "</h2>\n<div id=\"reportDetails\" class=\"ui grid\">\n\n  <div class=\"five wide column\">\n    <div class=\"ui segment fitted\">\n      <ui name=\"reportColumnGroups\" />\n    </div>\n  </div>\n\n  <div class=\"eleven wide column\">\n    <h3 class=\"accessibility-text\">" + escapeExpression((helper = (helper = helpers.reportOptionsTitle || (depth0 != null ? depth0.reportOptionsTitle : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "reportOptionsTitle",
        "hash": {},
        "data": data
      }) : helper)) + "</h3>\n    <div class=\"ui sticky\">\n\n      <div class=\"ui segment\">\n        <ui type=\"form\" name=\"reportForm\" />\n      </div>\n\n      <div class=\"ui segment\">\n        <ui type=\"form\" name=\"filterForm\" />\n      </div>\n\n      <div class=\"ui segments\">\n        <div class=\"ui segment\">\n          <span role=\"heading\" aria-level=\"3\" class=\"ui tiny header\">" + escapeExpression((helper = (helper = helpers.reportFields || (depth0 != null ? depth0.reportFields : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "reportFields",
        "hash": {},
        "data": data
      }) : helper)) + "</span>\n        </div>\n        <div class=\"ui padded segment\">\n          <ui name=\"reportColumns\" />\n        </div>\n      </div>\n\n    </div>\n  </div>\n</div>\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["report.filter.bar"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "<div class=\"ui grid\" style=\"font-size: 1em;\">\n  <div class=\"eight wide column right aligned right floated\">\n    <ui type=\"container\" name=\"headerRightContainer\"></ui>\n  </div>\n  <div class=\"eight wide column left floated\">\n    <ui type=\"container\" name=\"headerLeftContainer\"></ui>\n  </div>\n  <div style=\"clear: both;\"></div>\n</div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<!-- customized copy of page.list.hbs -->\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.headerOrBreadcrumbs : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\n<div class=\"ui segment " + escapeExpression((helper = (helper = helpers.searchSegmentColor || (depth0 != null ? depth0.searchSegmentColor : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "searchSegmentColor",
        "hash": {},
        "data": data
      }) : helper)) + " " + escapeExpression((helper = (helper = helpers.searchSegmentAttached || (depth0 != null ? depth0.searchSegmentAttached : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "searchSegmentAttached",
        "hash": {},
        "data": data
      }) : helper)) + " attached vs container reporting-filtering-bar-container\">\n  <ui name=\"visualsearchView\" />\n</div>\n<div class=\"ui segment bottom attached fitted\">\n</div>\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["sidebar.layout"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<div class=\"ui grid\">\n  <div class=\"twelve wide computer column main sixteen wide tablet\"></div>\n  <div class=\"four wide computer column sidebar sixteen wide tablet\"></div>\n</div>\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["study.detail"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "	<h3";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.hideTopSegmentHeaderFromScreens : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + ">" + escapeExpression((helper = (helper = helpers.topSegmentHeaderText || (depth0 != null ? depth0.topSegmentHeaderText : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "topSegmentHeaderText",
        "hash": {},
        "data": data
      }) : helper)) + "</h3>\n";
    },
    "2": function _(depth0, helpers, partials, data) {
      return " class=\"accessibility-text\"";
    },
    "4": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "	<h3";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.hideBottomSegmentHeaderFromScreens : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + ">" + escapeExpression((helper = (helper = helpers.bottomSegmentHeaderText || (depth0 != null ? depth0.bottomSegmentHeaderText : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "bottomSegmentHeaderText",
        "hash": {},
        "data": data
      }) : helper)) + "</h3>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.useTopSegmentHeader : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "<div id=\"studyDetails\" class=\"ui segment\">\n	<ui type=\"text\" tagname=\"span\" name=\"statusText\" ribbon=\"true\" classname=\"ui label ribbon\"/>\n	<table role=\"presentation\" class=\"ui very basic unstackable table\" style=\"margin-bottom: 0;\">\n		<tr>\n			<td style=\"width: 1%; white-space:nowrap\"><ui type=\"text\" name=\"label\" tagname=\"h4\" classname=\"ui header\" /></td>\n			<td>\n				<label for=" + escapeExpression((helper = (helper = helpers.titleFormId || (depth0 != null ? depth0.titleFormId : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "titleFormId",
        "hash": {},
        "data": data
      }) : helper)) + " class=\"accessibility-text\">Title: </label>\n				<ui type=\"form\" name=\"titleForm\"/>\n			</td>\n		</tr>\n	</table>\n	<ui type=\"form\" name=\"buttonForm\" />\n	<div class=\"ui divider\"></div>\n	<div class=\"ui hidden divider\" style=\"display: block !important\"></div>\n	<ui type=\"form\" name=\"studyForm\" />\n</div>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.useBottomSegmentHeader : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(4, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "<div class=\"ui segment bottom-tabs\">   <ui type=\"tabs\" name=\"tabs\" /> </div>\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["studylist.tabs.menu"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "  <div class=\"right menu\"></div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.rightAligned : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["submission.approvals.tab"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<h3 id=\"approvalsHeader\" class=\"accessibility-text\">" + escapeExpression((helper = (helper = helpers.submissionApprovalsHeaderText || (depth0 != null ? depth0.submissionApprovalsHeaderText : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "submissionApprovalsHeaderText",
        "hash": {},
        "data": data
      }) : helper)) + "</h3>\n<ui type=\"text\" name=\"investigatorLabel\" tagname=\"h4\" classname=\"ui header tab-submissions-approvals\" text=\"" + escapeExpression((helper = (helper = helpers.submissionResearchTeamHeader || (depth0 != null ? depth0.submissionResearchTeamHeader : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "submissionResearchTeamHeader",
        "hash": {},
        "data": data
      }) : helper)) + "\"></ui>\n<ui type=\"table\" name=\"investigatorTable\"></ui>\n<div class=\"ui hidden divider\" style=\"display: block !important\"></div>\n\n<ui type=\"text\" name=\"orgApproversLabel\" tagname=\"h3\" classname=\"ui header tab-submissions-approvals\" text=\"" + escapeExpression((helper = (helper = helpers.submissionOrgApproversHeader || (depth0 != null ? depth0.submissionOrgApproversHeader : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "submissionOrgApproversHeader",
        "hash": {},
        "data": data
      }) : helper)) + "\"></ui>\n<ui type=\"table\" name=\"orgApproversTable\"></ui>\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["submission.detail"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "	<h2";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.hideSubmissionDetailsHeaderFromScreens : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + ">" + escapeExpression((helper = (helper = helpers.submissionDetailsHeaderText || (depth0 != null ? depth0.submissionDetailsHeaderText : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "submissionDetailsHeaderText",
        "hash": {},
        "data": data
      }) : helper)) + "</h2>\n";
    },
    "2": function _(depth0, helpers, partials, data) {
      return " class=\"accessibility-text\"";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<div class=\"ui basic segment fitted\" style=\"margin-bottom: 2em;\">\n  <ui type=\"breadcrumb\" name=\"breadcrumb\"></ui>\n</div>\n\n<ui type=\"steps\" name=\"steps\"/>\n\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.useSubmissionDetailsHeader : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "<div id=\"submissionDetails\" class=\"ui segment details\">\n  <ui type=\"text\" tagname=\"span\" name=\"statusLabel\" ribbon=\"true\" classname=\"ui label ribbon\"></ui>\n  <ui type=\"container\" tagName=\"h3\" name=\"submissionHeader\"></ui>\n  <ui type=\"form\" name=\"actions\"></ui>\n  <div class=\"ui divider\" style=\"margin-top: 0;\"></div>\n\n  <div class=\"ui hidden divider\" style=\"display: block !important\"></div>\n\n  <ui type=\"form\" name=\"submissionForm\"></ui>\n\n  <div class=\"ui hidden divider\" style=\"display: block !important\"></div>\n\n  <ui type=\"tabs\" name=\"tabs\"></ui>\n</div>\n<ui type=\"dimmer\" name=\"dimmer\"></ui>\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["submissions.tab"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<ui type=\"table\" name=\"table\"></ui>";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["template.step"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["title.cell"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "    <div class=\"sub header\">" + escapeExpression((helper = (helper = helpers.subHeader || (depth0 != null ? depth0.subHeader : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "subHeader",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<div class=\"title-cell\">\n  <strong>\n    " + escapeExpression((helper = (helper = helpers.header || (depth0 != null ? depth0.header : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "header",
          "hash": {},
          "data": data
        }) : helper)) + "\n\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.subHeader : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "  </strong>\n</div>\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["upcoming.review"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<h4 class=\"ui header\">\n  " + escapeExpression((helper = (helper = helpers.boardName || (depth0 != null ? depth0.boardName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "boardName",
        "hash": {},
        "data": data
      }) : helper)) + "\n  <div class=\"sub header\">" + escapeExpression((helper = (helper = helpers.startTime || (depth0 != null ? depth0.startTime : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "startTime",
        "hash": {},
        "data": data
      }) : helper)) + " | " + escapeExpression((helper = (helper = helpers.location || (depth0 != null ? depth0.location : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "location",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n</h4>";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["upload.drop.item"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<div style=\"text-align: center;\">\n  <i class=\"icon upload\"></i> &nbsp; Drop To Add\n</div>";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["upload.item"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "    <img class=\"ui avatar image\" src=\"" + escapeExpression((helper = (helper = helpers.url || (depth0 != null ? depth0.url : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "url",
        "hash": {},
        "data": data
      }) : helper)) + "\" alt=\"" + escapeExpression((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "name",
        "hash": {},
        "data": data
      }) : helper)) + "\">\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.icon : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(4, data),
        "inverse": this.program(6, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "4": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "      <i class=\"icon " + escapeExpression((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "icon",
        "hash": {},
        "data": data
      }) : helper)) + "\"></i>\n";
    },
    "6": function _(depth0, helpers, partials, data) {
      return "      <i class=\"icon file outline\"></i>\n";
    },
    "8": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "      <div class=\"description\">" + escapeExpression((helper = (helper = helpers.description || (depth0 != null ? depth0.description : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "description",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<td style=\"vertical-align: middle;\" class=\"center aligned collapsing\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.url : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.program(3, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "</td>\n<td style=\"vertical-align: middle;\">\n  <div class=\"ui header small\" style=\"word-break: break-word;\">\n    " + escapeExpression((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "name",
        "hash": {},
        "data": data
      }) : helper)) + "\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.description : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(8, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "  </div>\n</td>\n<td style=\"vertical-align: middle;\">\n  <ui name=\"close\"></ui>\n</td>";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["upload.manager"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "multiple";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<div class=\"ui form\">\n  <input type=\"file\" class=\"file\" style=\"display: none;\" ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.multiple : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + ">\n  <ui name=\"choose\"></ui>\n</div>\n<table role=\"presentation\" class=\"ui table very basic\" style=\"width: 100%;\"></table>\n";
    },
    "useData": true
  });
  this["Handlebars"]["IRB"]["visual.search.token.report.filter"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "    <i class=\"" + escapeExpression((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "icon",
        "hash": {},
        "data": data
      }) : helper)) + " icon\"></i>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  <div class=\"dateType\">\n    <span class=\"column-name\">" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</span>\n  <ui type=\"form\" name=\"searchTokenForm\" />\n  </div>\n";
    },
    "5": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  <span class=\"column-name\">" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</span>\n  <div class=\"detail\">" + escapeExpression((helper = (helper = helpers.detail || (depth0 != null ? depth0.detail : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "detail",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n";
    },
    "7": function _(depth0, helpers, partials, data) {
      return "  <i class=\"close icon\"></i>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.icon : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.dateType : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.program(5, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.closeable : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "useData": true
  });
  return this["Handlebars"];
});

